import React from 'react';

import {AppButton} from '@/components/Button';
import RemoteIconV2 from '@/components/Icon/RemoteIconV2';
import {PENDING_RETURN_ACTION_IDS} from '@/consts/pendingReturnActionIds';
import useConfigExternalLink from '@/hooks/externalLink/useConfigExternalLink';
import useIsDesktopLayout from '@/hooks/layout/useIsDesktopLayout';
import usePendingReturnActionRedirect from '@/hooks/usePendingReturnActionRedirect';
import appContent from '@/services/content/appContent.typed';

const AutoDeliveryDcxPastOrdersButton = () => {
    const {pastOrdersButton} = appContent.getAutoDeliveryContent()?.extendedDetailsContent || {};
    const isDesktopLayout = useIsDesktopLayout();
    const {redirectToExternalLink} = useConfigExternalLink({...pastOrdersButton?.externalLink});
    const onClick = usePendingReturnActionRedirect(
        PENDING_RETURN_ACTION_IDS.AUTO_DELIVERY_DETAILS_EXTENDED,
        redirectToExternalLink
    );

    if (!redirectToExternalLink) return null;

    return (
        <AppButton
            className='shrink-0 items-center border-primary-dark-85 text-14 font-bold leading-[20px] md:font-normal ml:py-0 ml:text-primary'
            onClick={onClick}
            tertiary={isDesktopLayout}
            raw={!isDesktopLayout}
            aria-label={pastOrdersButton?.alt}
        >
            <span className='flex items-center md:gap-2'>
                {pastOrdersButton?.text}
                <RemoteIconV2 icon={pastOrdersButton?.icon} className='size-6' />
            </span>
        </AppButton>
    );
};

export default AutoDeliveryDcxPastOrdersButton;
